import { ChangeDetectorRef, Component, Inject, OnInit, ViewEncapsulation } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MAT_SNACK_BAR_DATA } from '@angular/material/snack-bar';
import { TranslateModule, TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'my-snackbar',
    template: `
  <div class="grid grid-rows-1 grid-flow-col gap-2">
    <div class="mt-3 row-span-1">
        <mat-icon [class]="getColor">{{ getIcon() }}</mat-icon>
    </div>
    <div class="mt-3 row-span-2">
        <span class="text-base" data-testid="message">{{ data.message  | translate:data.snackType?.params }}</span>
    </div>
  </div>
`,
    styles: [`
      my-snackbar {
          color: black !important;
      }
      .mdc-snackbar__surface {
          background-color: white !important;
      }
      .success-color {
          color: #16a34a !important;
      }
      .error-color {
          color: #a94442 !important;
      }
      .warning-color {
          color: #fbbf24 !important;
      }
      .info-color {
          color: #1e3a8a !important;
      }`,
    ],
    imports: [MatIconModule, TranslateModule],
    encapsulation: ViewEncapsulation.None
})
export class SnackbarComponent implements OnInit {

  constructor(@Inject(MAT_SNACK_BAR_DATA) public data: any) { }

  getIcon(): string {
    switch (this.data.title.toLowerCase()) {
      case 'success':
        return 'check_circle';
      case 'error':
        return 'error';
      case 'warning':
        return 'warning';
      case 'info':
        return 'info';
      default:
        return 'info';
    }
  }

  get getColor(): string {
    switch (this.data.snackType.type) {
      case 'success':
        return 'success-color';
      case 'error':
        return 'error-color';
      case 'warning':
        return 'warning-color';
      case 'info':
        return 'info-color';
      default: return "";
    }
  }

  ngOnInit(): void { }
}
